namespace SP {
    export enum PackageState {
        None = 0,
        Packed = 1,
        ScannedToPallet = 2,
    }
}